export const ARGUS_PENDING_PROMOTION_CODE_KEY = 'argus.pendingPromotionCode.v1'
export const ARGUS_PENDING_PROMOTION_CODE_EVENT = 'argus:pending-promotion-code'
const MAX_PENDING_AGE_MS = 30 * 24 * 60 * 60 * 1000

export function normalizePendingPromotionCode(value) {
  return String(value ?? '')
    .trim()
    .toUpperCase()
    .replace(/\s+/g, '')
}

export function isPendingPromotionCodeValid(value) {
  return /^[A-Z0-9][A-Z0-9_-]{2,39}$/.test(normalizePendingPromotionCode(value))
}

function emitPendingPromotionChange() {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent(ARGUS_PENDING_PROMOTION_CODE_EVENT))
}

export function rememberPendingPromotionCode(value) {
  if (typeof window === 'undefined') return false
  const code = normalizePendingPromotionCode(value)
  if (!isPendingPromotionCodeValid(code)) return false

  try {
    window.localStorage.setItem(
      ARGUS_PENDING_PROMOTION_CODE_KEY,
      JSON.stringify({ code, savedAt: Date.now() }),
    )
    emitPendingPromotionChange()
    return true
  } catch {
    return false
  }
}

export function clearPendingPromotionCode() {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.removeItem(ARGUS_PENDING_PROMOTION_CODE_KEY)
  } finally {
    emitPendingPromotionChange()
  }
}

export function readPendingPromotionCode(now = Date.now()) {
  if (typeof window === 'undefined') return null
  try {
    const raw = window.localStorage.getItem(ARGUS_PENDING_PROMOTION_CODE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    const code = normalizePendingPromotionCode(parsed?.code)
    const savedAt = Number(parsed?.savedAt)
    if (
      !isPendingPromotionCodeValid(code) ||
      !Number.isFinite(savedAt) ||
      Number(now) - savedAt > MAX_PENDING_AGE_MS
    ) {
      window.localStorage.removeItem(ARGUS_PENDING_PROMOTION_CODE_KEY)
      return null
    }
    return code
  } catch {
    window.localStorage.removeItem(ARGUS_PENDING_PROMOTION_CODE_KEY)
    return null
  }
}

export function pendingPromotionPath(code = readPendingPromotionCode()) {
  const normalized = normalizePendingPromotionCode(code)
  return isPendingPromotionCodeValid(normalized)
    ? `/promotions?code=${encodeURIComponent(normalized)}`
    : null
}
